const tools = [
  'OpenAI',
  'Claude / Anthropic',
  'n8n',
  'Google Gemini',
  'Firebase',
  'Vercel',
  'Stripe',
  'Supabase',
  'React',
  'Node.js',
  'TypeScript',
  'Tailwind',
];

const ToolItem = ({ name, isCopy }: { name: string; isCopy?: boolean }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '0 32px',
      flexShrink: 0,
      color: '#64748b',
      fontSize: 14,
      fontWeight: 500,
      whiteSpace: 'nowrap' as const,
      userSelect: 'none' as const,
    }}
  >
    <span style={{ width: 6, height: 6, borderRadius: '50%', background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', flexShrink: 0, display: 'inline-block' }} />
    {name}
    <span style={{ marginLeft: 32, width: 1, height: 16, background: 'rgba(226,232,240,0.6)', flexShrink: 0, display: 'inline-block' }} />
  </div>
);

const LogoBand = () => (
  <section
    className="py-10 border-y border-border-light overflow-hidden"
    style={{ backgroundColor: '#F8FAFC' }}
  >
    <p className="text-center text-[11px] font-semibold tracking-[0.2em] uppercase text-text-secondary/60 mb-6">
      Vi bygger med verktyg som faktiskt fungerar
    </p>

    <div style={{ overflow: 'hidden', position: 'relative' }}>
      {/* Fade edges */}
      <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: 80, background: 'linear-gradient(to right, #F8FAFC, transparent)', zIndex: 10, pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: 80, background: 'linear-gradient(to left, #F8FAFC, transparent)', zIndex: 10, pointerEvents: 'none' }} />

      <div
        className="marquee-track"
        style={{ display: 'flex', width: 'max-content' }}
      >
        {tools.map(name => <ToolItem key={name} name={name} />)}
        {tools.map(name => <ToolItem key={name + '-copy'} name={name} isCopy />)}
      </div>
    </div>
  </section>
);

export default LogoBand;
